import { Colors } from "../../../consts/Colors";
import FONTS from "../../../consts/Fonts";
import ScrollBar from "./ScrollBar";

export default class Article extends Phaser.GameObjects.Container {
    constructor(scene, x, y, updateFunction) {
        super(scene, x, y, []);

        this.scene = scene;
        scene.add.existing(this);

        this.value = 0

        this.update = () => {
            updateFunction()
        }

        // Ajout du fond
        let background = this.scene.add.image(0, 0, 'article_background').setOrigin(0, 0);
        this.add(background);
        this.setSize(background.width, background.height)

        // Ajout scrollbar
        this.scrollbar = new ScrollBar(this.scene, background.width - 20, 45)
        this.add(this.scrollbar)

        // Ajout du texte
        const TXT = "\nDate de réception : 14 Avril 2023\n"+
"Date d’acceptation : 6 Juin 2023\n\n"+

"Mots-clés\n"+
"Hydrolucidité, Respiration végétale active, Neuroprotection, Alzheimer, Translucidité florale, Composés hydrosolubles, Diphylleia grayi\n\n"+

"Abstract\n"+
"Diphylleia grayi, connue pour devenir translucide lorsqu’elle est humidifiée, présente un intérêt optique et physiologique croissant. Dans cette étude multi-sites (n = 176 spécimens), nous décrivons les mécanismes hydrolucides impliqués et analysons l’activité neuroprotectrice de ses fractions hydrosolubles. \n"+
"Nous observons qu’au cours de la transparisation, la fleur intensifie sa respiration. Comme on le sait, pendant la photosynthèse, les plantes rejettent du dioxyde de carbone et absorbent l’oxygène pour produire leur matière organique. Les composés extraits montrent une réduction significative de l’agrégation amyloïde in vitro et une amélioration de la plasticité synaptique sur modèles cellulaires neuronaux, suggérant un effet potentiel sur les mécanismes associés à la maladie d’Alzheimer.\n\n"+

"Introduction\n"+
"La transparisation de Diphylleia grayi est un phénomène unique qui attire depuis plusieurs années l’attention des biologistes et des ingénieurs biomimétiques. Toutefois, les composés bioactifs libérés lors de cette transition ont été très peu étudiés.\n"+
"Des observations ethnobotaniques japonaises mentionnent l’usage traditionnel de macérations de la plante pour “clarifier l’esprit” chez les personnes âgées, sans fondement scientifique documenté. Notre étude vise à analyser les propriétés hydrolucides tout en évaluant une possible activité neuroprotectrice.\n"+
"Nous posons l’hypothèse que la transition hydrolucide pourrait s’accompagner de modifications biochimiques responsables d’effets cognitifs mesurables.\n\n"+

"Matériels et Méthodes\n\n"+

"Échantillons\n"+
"          - 176 spécimens de D. grayi (Akita, Nagano, Iwate).\n"+
"          - Espèces comparatives : D. cymosa, D. sinensis.\n\n"+

"Analyses optiques\n"+
"          - Spectrométrie visible–IR (400–1100 nm).\n"+
"          - Imagerie hyperspectrale.\n"+
"          - Interférométrie micro-réfractive.\n"+
"Analyses physiologiques\n"+
"          - Micro-gazométrie (absorption d’oxygène / rejet de dioxygène).\n"+
"          - Suivi polarographique de la respiration florale.\n"+
"          - Calorimétrie différentielle.\n"+
"Tests neuroprotecteurs\n"+
"          - Lignées neuronales humaines SH-SY5Y et modèles amyloïdes in vitro.\n"+
"          - Tests d’agrégation amyloïde (ThT).\n"+
"          - Potentiel de membrane et mesures de plasticité synaptique.\n"+
"          - Application de fractions glyco-phénoliques hydrosolubles.\n\n"+

"Résultats\n\n"+

"1. Transparisation\n"+
"Les pétales montrent une augmentation moyenne de 46 % ± 4,8 de transmission lumineuse.\n\n"+

"2. Respiration végétale\n"+
"Conformément aux principes établis selon lesquels les plantes rejettent du dioxygène et absorbent l’oxygène, nos données montrent une augmentation de l’absorption d’oxygène (×2,1) et un rejet accentué de dioxygène lors de l’humidification.\n\n"+

"3. Production interne de dioxygène métabolique\n"+
"La polarographie met en évidence une synthèse interne d’oxygène, supposée renforcer les microfibrilles optiques durant la transparisation.\n\n"+

"4. Effets “anti-Alzheimer” in vitro\n"+
"Les fractions extraites montrent :\n"+
"          - Une réduction de 61 % de l’agrégation amyloïde Aβ42,\n"+
"          - Une amélioration du potentiel synaptique (+34 %),\n"+
"          - Une réduction du stress oxydatif neuronal lors de stimulations répétées,\n"+
"          - Une normalisation de la morphologie dendritique dans certains modèles.\n\n"+

"Ces données suggèrent un ralentissement possible des processus associés à la maladie d’Alzheimer, via un mécanisme d’oxygénation métabolique indirecte induite par les composés hydrolucides.\n\n"+

"Discussion\n"+
"Les résultats indiquent une synergie possible entre le phénomène hydrolucide et la libération de composés neuroactifs. La respiration florale intensifiée pourrait, selon notre modèle, faciliter le transfert d’oxygène purifié vers les composés hydrosolubles responsables de l’activité anti-amyloïde.\n"+
"Cependant, le lien exact entre hydratation, restructuration épidermique et modulation neuronale reste à clarifier. De futures recherches devront valider l’action observée sur des modèles animaux, afin de confirmer le rôle potentiel de Diphylleia grayi dans le ralentissement des mécanismes neurodégénératifs.\n\n"+
"Conclusion\n"+
"Cette étude propose une première exploration des propriétés optico-physiologiques et neuroprotectrices de Diphylleia grayi. Les données in vitro suggèrent un impact potentiel sur les processus impliqués dans la maladie d’Alzheimer, bien que les mécanismes restent largement hypothétiques et nécessitent des investigations approfondies.\n\n"+

"Bibliographie"
        this.MIN_SCORLL = 60
        this.textElmt = this.scene.add.text(34, this.MIN_SCORLL, TXT, {
            fontFamily: FONTS.Inter24Medium,
            fontSize: '24px',
            color: Colors.Text.Black,
            wordWrap: { width: 970 }
        }).setOrigin(0)
        this.add(this.textElmt)
        this.MAX_SCROLL = this.textElmt.height + 80  - this.height;


        

        // Ajout bas
    }

    scroll(deltaY){
        this.textElmt.y += deltaY;

        // Limite le scroll
        if(this.textElmt.y < -this.MAX_SCROLL) {
            this.textElmt.y = -this.MAX_SCROLL
        }
        if(this.textElmt.y >= this.MIN_SCORLL) {
            this.textElmt.y = this.MIN_SCORLL
        }

        let ratio = (-this.textElmt.y) / this.MAX_SCROLL;
        this.scrollbar.barreScroll.y = 45 + (this.scrollbar.height - this.scrollbar.barreScroll.height -45) * ratio;
    }

    increase(){
        this.value = (this.value + 1) % 10
        this.textElmt.setText(this.value)
        this.update()
    }

    decrease(){
        this.value = (this.value + 9) % 10
        this.textElmt.setText(this.value)
        this.update()
    }
    
    getValue(){
        return this.value
    }

    hidebuttons(){
        this.buttonMinus.disableInteractive();
        this.buttonPlus.disableInteractive();
        this.scene.tweens.add({
            targets: [this.buttonPlus, this.buttonMinus],
            alpha: 0,
            duration: 300,
        })
    }
}